/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AnyValueModelString } from '../model/anyValueModelString';
// @ts-ignore
import { AnyValueModelUUID } from '../model/anyValueModelUUID';
// @ts-ignore
import { CarrierBusinessRequest } from '../model/carrierBusinessRequest';
// @ts-ignore
import { CarrierModel } from '../model/carrierModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CarrierProfileService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PROFILE_FULL: Edit carrier address
     * @endpoint put /carrier/profile/{carrierId}/edit/address
     * @param carrierId 
     * @param anyValueModelString 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public carrierProfileEditAddress(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CarrierModel>;
    public carrierProfileEditAddress(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CarrierModel>>;
    public carrierProfileEditAddress(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CarrierModel>>;
    public carrierProfileEditAddress(carrierId: string, anyValueModelString: AnyValueModelString, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (carrierId === null || carrierId === undefined) {
            throw new Error('Required parameter carrierId was null or undefined when calling carrierProfileEditAddress.');
        }
        if (anyValueModelString === null || anyValueModelString === undefined) {
            throw new Error('Required parameter anyValueModelString was null or undefined when calling carrierProfileEditAddress.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/carrier/profile/${this.configuration.encodeParam({name: "carrierId", value: carrierId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/edit/address`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CarrierModel>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: anyValueModelString,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PROFILE_FULL: Edit business
     * @endpoint put /carrier/profile/{carrierId}/edit/business
     * @param carrierId 
     * @param carrierBusinessRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public carrierProfileEditBusiness(carrierId: string, carrierBusinessRequest: CarrierBusinessRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CarrierModel>;
    public carrierProfileEditBusiness(carrierId: string, carrierBusinessRequest: CarrierBusinessRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CarrierModel>>;
    public carrierProfileEditBusiness(carrierId: string, carrierBusinessRequest: CarrierBusinessRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CarrierModel>>;
    public carrierProfileEditBusiness(carrierId: string, carrierBusinessRequest: CarrierBusinessRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (carrierId === null || carrierId === undefined) {
            throw new Error('Required parameter carrierId was null or undefined when calling carrierProfileEditBusiness.');
        }
        if (carrierBusinessRequest === null || carrierBusinessRequest === undefined) {
            throw new Error('Required parameter carrierBusinessRequest was null or undefined when calling carrierProfileEditBusiness.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/carrier/profile/${this.configuration.encodeParam({name: "carrierId", value: carrierId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/edit/business`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CarrierModel>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: carrierBusinessRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PROFILE_FULL: Edit insurance
     * @endpoint put /carrier/profile/{carrierId}/edit/insurance
     * @param carrierId 
     * @param anyValueModelString 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public carrierProfileEditInsurance(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AnyValueModelUUID>;
    public carrierProfileEditInsurance(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AnyValueModelUUID>>;
    public carrierProfileEditInsurance(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AnyValueModelUUID>>;
    public carrierProfileEditInsurance(carrierId: string, anyValueModelString: AnyValueModelString, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (carrierId === null || carrierId === undefined) {
            throw new Error('Required parameter carrierId was null or undefined when calling carrierProfileEditInsurance.');
        }
        if (anyValueModelString === null || anyValueModelString === undefined) {
            throw new Error('Required parameter anyValueModelString was null or undefined when calling carrierProfileEditInsurance.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/carrier/profile/${this.configuration.encodeParam({name: "carrierId", value: carrierId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/edit/insurance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AnyValueModelUUID>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: anyValueModelString,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PROFILE_FULL: Edit ss4
     * @endpoint put /carrier/profile/{carrierId}/edit/ss4
     * @param carrierId 
     * @param anyValueModelString 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public carrierProfileEditSs4(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AnyValueModelUUID>;
    public carrierProfileEditSs4(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AnyValueModelUUID>>;
    public carrierProfileEditSs4(carrierId: string, anyValueModelString: AnyValueModelString, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AnyValueModelUUID>>;
    public carrierProfileEditSs4(carrierId: string, anyValueModelString: AnyValueModelString, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (carrierId === null || carrierId === undefined) {
            throw new Error('Required parameter carrierId was null or undefined when calling carrierProfileEditSs4.');
        }
        if (anyValueModelString === null || anyValueModelString === undefined) {
            throw new Error('Required parameter anyValueModelString was null or undefined when calling carrierProfileEditSs4.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/carrier/profile/${this.configuration.encodeParam({name: "carrierId", value: carrierId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/edit/ss4`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AnyValueModelUUID>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: anyValueModelString,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PROFILE_READ: Carrier
     * @endpoint get /carrier/profile/{carrierId}
     * @param carrierId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public carrierProfileGet(carrierId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CarrierModel>;
    public carrierProfileGet(carrierId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CarrierModel>>;
    public carrierProfileGet(carrierId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CarrierModel>>;
    public carrierProfileGet(carrierId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (carrierId === null || carrierId === undefined) {
            throw new Error('Required parameter carrierId was null or undefined when calling carrierProfileGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/carrier/profile/${this.configuration.encodeParam({name: "carrierId", value: carrierId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CarrierModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
